import { DynamicFormControlLayout, DynamicFormControlModel, DynamicFormControlModelConfig, serializable } from '@ng-dynamic-forms/core';

export const TYPE_INFO = 'INFO';

export interface InfoComponentModelConfig extends DynamicFormControlModelConfig {
  icon?: string;
  heading?: string;
  content?: string;
  contentValues?: Record<string, string>;
  isInstruction?: boolean;
}

export class InfoComponentModel extends DynamicFormControlModel {
  @serializable() readonly type: string = TYPE_INFO;

  @serializable() icon: string;
  @serializable() heading: string;
  @serializable() content: string;
  @serializable() contentValues: Record<string, string>;
  @serializable() isInstruction: boolean;

  constructor(config: InfoComponentModelConfig, layout?: DynamicFormControlLayout) {
    super(config, layout);

    this.icon = config.icon || null;
    this.heading = config.heading || null;
    this.content = config.content || null;
    this.contentValues = config.contentValues || null;
    this.isInstruction = config.isInstruction || false;
  }
}
